import { Close, ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React, { useState } from 'react';

import { useForwardedRef } from '@/hooks/useForwardedRef';

import { useLocationAutocompleteContext } from './LocationAutocompleteContext';
import { useLocationFilterContext } from './LocationFilterContext';

interface ILocationFilterInputProps {
  label: string;
}

export const LocationFilterInput = ({ label }: ILocationFilterInputProps) => {
  const { inputProps } = useLocationAutocompleteContext();
  const { setAddressValue, setMapboxValues } = useLocationFilterContext();
  const [isFocused, setIsFocused] = useState(false);
  const useLabelAsPlaceholder = !!inputProps.value || isFocused;

  const materialUIRef = (inputProps as any).ref;
  const { internalRef, forwardedRef } = useForwardedRef<HTMLInputElement>(materialUIRef);

  const handleClear = () => {
    setAddressValue('');
    setMapboxValues('', '');
    internalRef.current?.focus();
  };

  return (
    <div className="relative flex flex-row justify-between w-full min-w-0 text-left h-[100px]">
      <div className="flex flex-col justify-center w-full min-w-0">
        <Text
          variant={
            useLabelAsPlaceholder ? ETextStyleVariant.LegalRegular : ETextStyleVariant.LargeRegular
          }
          component="span"
          className={cn(
            'text-gray-500 truncate absolute transition-all duration-300 ease-in-out min-w-0 left-4 right-4',
            {
              '-translate-y-3': useLabelAsPlaceholder,
              'translate-y-0': !useLabelAsPlaceholder,
            },
          )}>
          {label}
        </Text>
        <input
          {...inputProps}
          ref={forwardedRef}
          className={cn(
            'absolute left-4 right-8 top-0 bottom-0 bg-transparent truncate pt-9 pb-4 min-w-0',
            'text-gray-800 tracking-normal text-lg font-medium',
            {
              'placeholder-transparent': !useLabelAsPlaceholder,
              'placeholder-gray-800': useLabelAsPlaceholder,
            },
          )}
          onFocus={e => {
            e.target.select();
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
        />
      </div>
      {inputProps.value && (
        <div className="flex items-center justify-center w-12 h-full">
          <div className="absolute flex items-center justify-center right-3">
            <Close onClose={handleClear} ariaLabel="Clear search" />
          </div>
        </div>
      )}
    </div>
  );
};
